/**
 * Created by jv on 2019-09-11 (10:14).
 */
const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
import WebSocketClient from "Sources/realtime/client";

class RealtimeServiceController
{
  constructor(options)
  {
    this.baseUrl = options.baseUrl;
    if(utils.isNotNull(this.baseUrl) && this.baseUrl.endsWith("/"))
      this.baseUrl = this.baseUrl.substring(0, this.baseUrl.length - 1);

    this.onOpenListeners = [];
    this.onCloseListeners = [];
    this.onErrorListeners = [];
    this.onMessageListeners = [];
  }

  init()
  {
    this.url = this.baseUrl;

    this.client = new WebSocketClient({
      url: this.url,
      onOpen: (event) => this._onSessionOpened(event),
      onClose: (event) => this._onSessionClosed(event),
      onError: (event) => this._onSessionError(event),
      onMessage: (event) => this._onSessionMessage(event)
    });
  }

  _onSessionOpened(event)
  {
    log.cssLog("Successfully established socket connection - %o", event, log.successCss);

    for(let i = 0; i < this.onOpenListeners.length; i++)
    {
      this.onOpenListeners[i].call(this, event);
    }
  }

  _onSessionClosed(event)
  {
    log.cssLog("Socket connection was closed - %o", event, log.warningCss);

    for(let i = 0; i < this.onCloseListeners.length; i++)
    {
      this.onCloseListeners[i].call(this, event);
    }
  }

  _onSessionError(event)
  {
    log.cssLog("An error occurred on the socket connection - %o", event, log.errorCss);

    for(let i = 0; i < this.onErrorListeners.length; i++)
    {
      this.onErrorListeners[i].call(this, event);
    }
  }

  _onSessionMessage(event)
  {
    for(let i = 0; i < this.onMessageListeners.length; i++)
    {
      this.onMessageListeners[i].call(this, event);
    }
  }

  connect()
  {
    if(utils.isNotNull(this.client))
    {
      this.client.open();
    }
  }

  disconnect()
  {
    if(utils.isNotNull(this.client))
    {
      this.client.close();
    }
  }

  sendMessage(message)
  {
    let serializedData = message.serialize();
    log.info("Sending message to server: %o\nSerialized: %s", message, serializedData);

    this.client.sendData(serializedData);
  }

  addEventListener(type, func)
  {
    if(utils.isNull(type) || !utils.isFunction(func))
      return;

    switch(type)
    {
      case "session-opened":
        this.onOpenListeners.push(func);
        break;
      case "session-closed":
        this.onCloseListeners.push(func);
        break;
      case "session-error":
        this.onErrorListeners.push(func);
        break;
      case "session-message":
        this.onMessageListeners.push(func);
        break;
    }
  }
}

export default RealtimeServiceController;



// WEBPACK FOOTER //
// ./app/js/controllers/realtime-service-controller.js